module.exports = __webpack_public_path__ + "static/media/public_islamic_bank.2dc19c9d.svg";